import styled from 'styled-components';

export const Comment = styled.div`
  padding-bottom: 1.5rem;
`;
